import { render } from "./TopicsActionBar.vue?vue&type=template&id=c85a8652"
import script from "./TopicsActionBar.vue?vue&type=script&lang=js"
export * from "./TopicsActionBar.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployuser/prod/immivo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__